import Template from "@/assets/js/template.js";
import VariableGroup from "@/assets/js/variableGroup.js";
import VariableHelpers from "@/assets/js/variableHelpers.js";
import ConfirmModal from "@/components/modals/ConfirmModal";
import ExtendSession from "@/components/modals/ExtendSession";
import PlanExpired from "@/components/modals/PlanExpired";
import Connector from "@/assets/js/connector.js";
import router from "../router";
import Vue from "vue";
import Vuex from "vuex";
import i18n from "../i18n";
let _countryCodes = require('@/assets/data/validCountryCodes.json')
let _connectors = require('@/assets/data/connectors.json')
let _formatWhiteList = require('@/assets/data/formatWhiteList.json')

Vue.use(Vuex);
const STORAGE_KEY = "language-storage";

export default new Vuex.Store({
  state: {
    activeTextEditor: null,
    sentenceBeingEdited: null,
    sentenceEditorPreview: null, // when editing a sentence, this is the preview shown in the right-side panel
    sentencePreviewPopoverIsBlocked: false,
    variantBeingEdited: null,
    templateSectionBeingEdited: null,
    templateSectionBeingNamed: "",
    templateSectionBeingNamedAndID: "",
    template: null,
    templatePreview: null, // this is the main preview
    templateVariables: [],
    variableFormats: null,
    activePath: [],
    user: null,
    users: [],
    apiKeys: [],
    scopes: [],
    organization: null,
    token: JSON.parse(localStorage.getItem("token")),
    templates: [],
    unsavedChanges: false,
    currentDatasetId: null,
    templateDataSearchResults: [],
    contentSources: [],
    contentSources2: [],
    dummyData: [],
    contentTypes: [],
    publicationStats: null,
    publicationSingleItemStats: [],
    apiUrl:
      document.location.hostname.indexOf("dev.") > -1
        ? "http://dev.api.icrobotics.com:63342/"
        : document.location.hostname.indexOf("staging") > -1 ||
          document.location.hostname.indexOf("192.168") > -1 ||
          document.location.hostname.indexOf("localhost") > -1
        ? "https://staging.api.icrobotics.com/"
        : "https://api.icrobotics.com/",
    filters: [
      { name: i18n.t("home.all"), id: "all", categories: [], custom: "all" },
    ],
    formatWhiteList: _formatWhiteList,
    connectorSettings: [],
    exclusiveDropdown: null,
    dataFavorites: [],
    selectedDataset: "",
    templateMultiplePreview: [],
    templateMultipleDatasets: [],
    showTooltips: null,
    showingTemplateBackupInPreview: false,
    originalTemplateData: null,
    templateBackups: [],
    handlingExpiredToken: false,
    fixedConnectors: _connectors,
    subscriptionPlans: [],
    billingInfoTemporary: null,
    validCountryCodes: _countryCodes,
    // planExpired: false,
    loadingRoute: false,
    draggedVariant: null,
    draggedVariantList: null,
    sentenceDraggedFrom: null,
    draggedScenario: null,
    draggedSentencelist: null,
    scenarioIndex: null,
    draggingScenarioGroup: false,
    scrollToPath: false,
    templatePreviewAsHTML: false,
  },
  getters: {
    combinedVariables(state) {
      if (!state.template || !state.templateVariables) return {};
      let vars = [
        ...(state.templateVariables || []),
        ...(state.template.extraVariables.map((v) => ({
          custom: true,
          type: "Bool",
          ...v,
        })) || []),
      ].reduce((vars, v) => {
        vars[v.name] = v;
        return vars;
      }, {});
      let varCount = VariableHelpers.countVariablesInTemplate(state.template);
      // go through variables and add dynamic ones (e.g. player3, player4 etc.)
      // first lets find the variables that are dynamic (including a number in the name)
      let allDynamicVars = Object.keys(vars).reduce((dynVars, v) => {
        if (/\d+/g.test(v)) dynVars[v.replace(/\d+/g, "")] = vars[v];
        return dynVars;
      }, {});
      // now let's go through the ones in the template that does not exist yet in the variables
      let notFound = Object.keys(varCount).filter((v) => !vars[v]);
      // for each dynamic variable not found, add it using the existing one as a template
      notFound.forEach((v) => {
        let existing = allDynamicVars[v.replace(/\d+/g, "")];
        if (existing) vars[v] = { ...JSON.parse(JSON.stringify(existing)), name: v };
        else console.log("Unknown:", v);
      });

      return vars;
    },
    variableGroups(state, getters) {
      return new VariableGroup(VariableHelpers.groupVariables(getters.combinedVariables));
    },
    language(state) {
      return i18n.locale || i18n.fallbackLocale;
    },
    // stripePublicKey(state){
    //   return state.apiUrl == "https://api.icrobotics.com/" ? "pk_live_51Jr1eALwD4JTIsAvTq4RbmMKt0JP28Z5OFl5sAZeXTcbBY4NAREMtKXCNuFksPND43VWTYgjjHuAAWG4rB8CZ0E800VPvI7Tkc" : "pk_test_51Jr1eALwD4JTIsAv0PZFSoIScykT7EM2sW5yucfntBfC3hgPsTLgHvZ5dTjIwCI8akm0jLZwfteSvZCevbEVjvan00I0KQ0jyu"
    // },
    // trialEnding(){
    //   // return new Date('January 14, 2021 23:59:59')
    //   return false
    // },
    // versionIsTrial(){
    //   // Temporary --- Sets the limitations for trial users + countdownbanner content
    //   return false
    // }
  },
  mutations: {
    setToken(state, token) {
      console.log("setting new token");
      localStorage.setItem("token", JSON.stringify(token));
      state.token = token;
    },
    clearEditorState({ state }) {
      this.state.sentenceBeingEdited = null;
      this.state.templateDataSearchResults = [];
      this.state.currentDatasetId = null;
    },
    addFileName(state, { template }) {},
    addSentenceToTemplate(state, { templateName, variable }) {
      if (!variable || !templateName) {
        return;
      }
      const template = state.template[templateName];
      console.log(`template: ${JSON.stringify(template, null, 2)}`);
      let sentence = {
        texts: [],
        number: 1,
        priority: 1,
        conditions: [
          {
            expression: "",
          },
        ],
      };
      sentence.texts.push(`${variable.name}`);
      template[templateName].push(sentence);
      console.log(`section: ${template[templateName]}`);
      Vue.set(state, "template", template);
    },
    addTemplateVariable(state, { variable }) {
      const templateVars = state.templateVariables;
      if (variable) {
        templateVars.push(variable);
      }
      console.log(`template variables: ${JSON.stringify(templateVars, null, 2)}`);
      Vue.set(state, "templateVariables", templateVars);
    },
    setVariantBeingEdited(state, variant) {
      if (state.variantBeingEdited && state.variantBeingEdited != variant) {
        state.variantBeingEdited.stopEditing();
      }
      state.variantBeingEdited = variant;
      variant.edit();
    },
    blockSentencePreviewPopover(state) {
      Vue.set(state, "sentencePreviewPopoverIsBlocked", true);
    },
    setSentenceBeingEdited(state, sentence) {
      Vue.set(state, "scrollToPath", true);
      Vue.set(state, "sentenceBeingEdited", sentence);
    },
    setSentenceEditorPreview(state, preview) {
      Vue.set(state, "sentenceEditorPreview", preview);
    },
    setActiveTextEditor(state, editor) {
      Vue.set(state, "activeTextEditor", editor);
    },
    setTemplateSectionBeingEdited(state, section) {
      Vue.set(state, "templateSectionBeingEdited", section);
    },
    setTemplateSectionBeingNamed(state, sectionName) {
      Vue.set(state, "templateSectionBeingNamed", sectionName);
    },
    setTemplateSectionBeingNamedAndID(state, sectionId) {
      Vue.set(state, "templateSectionBeingNamedAndID", sectionId);
    },
    setExclusiveDropdown(state, dropdown) {
      Vue.set(state, "exclusiveDropdown", dropdown);
    },
    toggleScrollToPath(state) {
      Vue.set(state, "scrollToPath", !state.scrollToPath);
    },
    renameTemplateSynonym(state, data) {
      const index = state.template.globalSynonyms.findIndex((s) => s.name == data.synonymName);
      Vue.set(state.template.globalSynonyms[index], "name", data.newName);
    },
    replaceTextByRegex(state, data) {
      state.template.replaceByRegex(data.query, data.replacement, data.pattern);
    },
    replaceTextByRegexInCurrentSection(state, data) {
      state.templateSectionBeingEdited.replaceByRegex(data.query, data.replacement, data.pattern);
    },
    transformTemplateSynonyms(state, data) {
      state.template.transformTemplateSyn(data.synonym, data.pattern);
    },
    transformTemplateSynonymsInCurrentSection(state, data) {
      state.templateSectionBeingEdited.transformTemplateSyn(data.synonym, data.pattern);
    },

    // setActiveTextEditorContents(state, { editor, sentences }) {
    //     sentences.forEach(sentence => {
    //         sentence = new SentencePreview(sentence, this.sectionId)
    //         if (!sentence.sentences) {
    //             contents.push({ insert: sentence.text })
    //         } else {
    //             contents.push({ insert: { sentence: sentence } })
    //         }
    //     })
    //     console.log(`newly entered text: ${newlyEnteredText}`)
    //     editor.setContents(contents)
    //     // Vue.set(state, 'activeTextEditor', editor)
    // },
    setTemplateData(state, { template, variables }) {
      // todo: new Template(template)
      Vue.set(state, "template", new Template(template));
      Vue.set(state, "templateVariables", variables);
      this.unsavedChanges = false;
    },
    unblockSentencePreviewPopover(state) {
      Vue.set(state, "sentencePreviewPopoverIsBlocked", false);
    },
    setSelectedDataset(state, { selectedDataset }) {
      console.log(selectedDataset);
      Vue.set(state, "selectedDataset", selectedDataset);
    },
    toggleShowTooltips(state) {
      Vue.set(state, "showTooltips", !state.showTooltips);
      localStorage.setItem("toggleShowTooltips", state.showTooltips);
    },

    //Drag n drop functionality

    dragVariant(state, data) {
      Vue.set(state, "draggedVariant", data.draggedVariant);
      Vue.set(state, "draggedVariantList", data.draggedVariantList);
      Vue.set(state, "sentenceDraggedFrom", data.sentenceDraggedFrom);
    },
    dropVariantInList(state, itemIndex) {
      // const updatedVariantList = state.draggedVariantList.variants.splice(itemIndex, 1);
      state.draggedVariantList.remove(state.draggedVariant);
      // Vue.set(state, "draggedVariantList", updatedVariantList);
    },
    dragVariantEnded(state) {
      Vue.set(state, "draggedVariant", null);
      Vue.set(state, "draggedVariantList", null);
      Vue.set(state, "sentenceDraggedFrom", null);
    },

    dragScenario(state, data) {
      Vue.set(state, "draggedScenario", data.draggedScenario);
      // Vue.set(state, "draggedSentencelist", data.draggedSentencelist);
      // Vue.set(state, "scenarioIndex", data.scenarioIndex);
    },

    dragScenarioEnded(state) {
      Vue.set(state, "draggedScenario", null);
      // Vue.set(state, "draggedSentencelist", null);
      // Vue.set(state, "scenarioIndex", null);
    },

    removeScenario(state, data) {
      state.templateSectionBeingEdited.findSentenceListById(data.sentenceListId).removeById(data.sentenceId);
    },

    addScenarioToNewList(state, data) {
      state.templateSectionBeingEdited.findSentenceListById(data.newSentenceListId).sentences.push(data.scenario);
      state.templateSectionBeingEdited.setPaths([]);
      Vue.set(state, "activePath", data.scenario.path);
    },

    refreshPathsInSection(state) {
      state.templateSectionBeingEdited.setPaths([]);
    },

    dragScenarioGroupStarted(state) {
      Vue.set(state, "draggingScenarioGroup", true);
    },

    dragScenarioGroupEnded(state) {
      Vue.set(state, "draggingScenarioGroup", false);
    },

    setTemplateSettings(state, templateData) {
      const index = state.templates.findIndex((t) => t.id == templateData.id);
      console.log(index);
      console.log(state.templates[index]);
      Vue.set(state.templates[index], "settings", templateData.settings);
    },

    updateUserInfo(state, userInfo) {
      Vue.set(state, "user", userInfo);
    },

    setTemplatePreview(state, preview) {
      Vue.set(state, "templatePreview", preview);
    },
    toggleTemplatePreviewAsHTML(state) {
      Vue.set(state, "templatePreviewAsHTML", !state.templatePreviewAsHTML);
    },

    addTemplate(state, template) {
      state.templates.push(template);
    },
  },
  actions: {
    cloneScenarioGroup({ state }, data) {
      console.log(data.number);
      let clones = [];
      state.templateSectionBeingEdited
        .findSentenceListById(data.sentenceListId)
        .sentences.filter((s) => s.number == data.number)
        .forEach((s) => {
          let clone = s.clone();
          clone.oldId = s.id;
          clones.push(clone);
        });
      return clones;
    },
    cloneScenario({ state }, data) {
      return state.templateSectionBeingEdited
        .findSentenceListById(data.sentenceListId)
        .getById(data.sentenceId)
        .clone();
    },
    getTemplateData({ state, dispatch, commit }, templateId) {
      return new Promise((resolve, reject) => {
        // commit('setTemplateData', { template, variables })
        let template = state.templates.find((t) => t.id == templateId);
        if (!template) {
          reject("notfound");
        } else {
          Promise.all([dispatch("getTemplate", template.id), dispatch("getVariables", { template })]).then(
            (results) => {
              commit("setTemplateData", {
                template: results[0],
                variables: results[1],
              });
              dispatch("getTemplatePreview", {
                template: state.template,
                variables: state.templateVariables,
              }).then((preview) => {
                dispatch("getTemplateBackups", templateId),
                  // dispatch("getFavorites")
                  (state.templatePreview = preview);
                dispatch("getFavorites");
                resolve(preview);
              });
            },
            reject,
          );
        }
      });
    },
    getTemplate({ state }, templateId) {
      // return new Promise((resolve, reject) => {
      //   resolve(templateFile)
      // })
      return Vue.http.get("templates/" + templateId).then((result) => result.body);
    },

    getVariables({ state, dispatch }, { template, id }) {
      return Vue.http
        .get(`templates/${template.id}/metadata/variables` + (id ? `?contentId=${encodeURIComponent(id)}` : ""))
        .then((result) => result.body);
    },

    updateTemplateMethods({ state, dispatch }, updatedMethods) {
      dispatch("getTemplate", state.template.metadata.id).then((r) => {
        r.methods = updatedMethods;
        return Vue.http
          .put("templates/" + state.template.metadata.id, r)
          .then((res) => {
            console.log("Should only save and update template methods", res);
          })
          .catch((e) => console.log("some error:", e));
      });
    },

    saveTemplateChanges({ state, dispatch }) {
      console.log(state.template.export());
      return Vue.http.put("templates/" + state.template.metadata.id, state.template.export()).then(() => {
        state.unsavedChanges = false;
        dispatch("getTemplateBackups", state.template.metadata.id);
      });
    },
    getSentencePreview({ state }, sentence) {
      // first ignore the first condition
      let template = {
        metadata: state.template.metadata,
        extraVariables: state.template.extraVariables,
        globalSynonyms: state.template.globalSynonyms,
        methods: state.template.methods,
        sections: [{ sentences: [{ texts: [sentence] }], name: "Body", id: "body" }],
        language: state.template.language,
      };
      return Vue.http
        .post("editor/previewtemplate?includeVariableNames=false", {
          template: template,
          variables: state.templateVariables,
        })
        .then((result) => {
          return result.body.sections[0].result ? result.body.sections[0].result.sentences : null;
        });
    },
    getTemplatePreview(
      { state, dispatch },
      { template, variables, includeVariableNames = !state.templatePreviewAsHTML },
    ) {
      // return new Promise((resolve, reject) => {
      //   resolve(templatePreviewFile)
      // })
      // console.log(router.currentRoute);
      let seed = router.currentRoute ? router.currentRoute.query.seed || null : null;
      return Vue.http
        .post(
          "editor/previewtemplate?includeVariableNames=" + includeVariableNames + (seed ? "&seed=" + seed : ""),
          { template: template.export(), variables: variables },
          // { template: !backupPreview ? template.export() : template, variables: variables }
        )
        .then((result) => result.body);
    },

    refreshAllPreviews({ state, dispatch }) {
      state.templateMultiplePreview.forEach((preview) => {
        preview.loading = true;
        dispatch("getTemplatePreview", {
          template: state.template,
          variables: preview.variables,
        }).then((newPreview) => {
          preview.preview = newPreview;
          preview.loading = false;
        });
      });
    },

    variableClicked({ state }, { node, variable, clickEvent }) {
      if (state.activeTextEditor) {
        state.activeTextEditor.$emit("variable-clicked", {
          node,
          variable,
          event,
        });
      }
    },
    testExpression({ state, getters }, expression) {
      // return new Promise((resolve, reject) => {
      //     resolve({ result: true, valid: true })
      // })
      return Vue.http
        .post("editor/expressions/check", {
          expression: expression,
          dependentVariables: VariableHelpers.getDependentVariables(expression, getters.combinedVariables).reverse(), // Reverse - then checking the expressions also works if the users uses extravariables in extravariables
        })
        .then((result) => result.body);
    },
    setActivePath({ state, dispatch }, path) {
      console.log("active path set: " + path);
      Vue.set(state, "activePath", path);
    },
    cleanUpTemplate({ state }, template) {
      // clean up a template
    },

    setCategoryFilter({ state, commit }) {
      if (state.filters.length <= 1) {
        state.contentTypes.map((c) => {
          let filter = {
            name: c.name,
            id: c.id,
            categories: [c.name],
            custom: c.custom,
          };
          state.filters.push(filter);
        });
      }
    },

    signUp({ state, dispatch }, data) {
      return new Promise((resolve, reject) => {
        Vue.http
          .post("organizations", data)
          .then(() => {
            const loginDetails = {
              email: data.user.username,
              password: data.user.password,
            };
            router.push("login");
            dispatch("logIn", loginDetails).then((res) => {
              router.push("home");
            });
            resolve(true);
          })
          .catch((error) => {
            reject(error);
            console.log("register error");
          });
      });
    },

    logIn({ state, commit }, { email, password }) {
      return new Promise((resolve, reject) => {
        return Vue.http
          .post("login", { username: email, password: password, grant_type: "password" }, { emulateJSON: true })
          .then((result) => {
            commit("setToken", result.body);
            resolve(true);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    logOut({ state }) {
      return new Promise((resolve, reject) => {
        localStorage.removeItem("token");
        Vue.delete(state, "user", null);
        Vue.delete(state, "token", null);
        resolve();
      });
    },

    handleExpiredToken({ state }) {
      // console.log( state.user.username  ) //login email
      if (!state.handlingExpiredToken) {
        state.handlingExpiredToken = true;
        let modal = this._vm.$modal;
        modal.show(
          ExtendSession,
          {
            title: i18n.t("extend-session.title"),
            description: i18n.t("extend-session.description"),
            confirmButtonText: i18n.t("extend-session.button"),
            userDetails: state.user,
          },
          { width: 450, height: "auto", adaptive: true, clickToClose: false },
        );
      }
    },

    handleExpiredPlan({ state }) {
      if (router.currentRoute.name == "template" && state.unsavedChanges) {
        console.log("editing a template & changes are made");
      }
      let modal = this._vm.$modal;
      modal.show(
        PlanExpired,
        {
          title: i18n.t("expired.title"),
          description: i18n.t("expired.description"),
          showSavingOptions: router.currentRoute.name == "template" && state.unsavedChanges,
        },
        { width: 450, height: "auto", adaptive: true, clickToClose: false },
      );
    },

    getUser({ state, commit }) {
      return new Promise(async (resolve, reject) => {
        if (state.user) resolve(state.user);
        else {
          state.user = (await Vue.http.get("users/me")).body;
          resolve(state.user);
        }
      });
    },
    getUsers({ state, commit }, refresh) {
      return new Promise(async (resolve, reject) => {
        if (!refresh && state.users.length) resolve(state.users);
        else {
          state.users = (await Vue.http.get("organizations/me/users")).body;
          resolve(state.users);
        }
      });
    },
    getApiKeys({ state, commit }) {
      return new Promise(async (resolve, reject) => {
        if (state.apiKeys.length) resolve(state.apiKeys);
        else {
          state.apiKeys = (await Vue.http.get("organizations/me/apikeys")).body;
          resolve(state.apiKeys);
        }
      });
    },

    getScopes({ state, commit }) {
      return new Promise(async (resolve, reject) => {
        if (state.scopes.length) resolve(state.scopes);
        else {
          state.scopes = (await Vue.http.get("organizations/me/apikeys/scopes")).body;
          resolve(state.scopes);
        }
      });
    },

    getOrganization({ state, commit }) {
      return new Promise(async (resolve, reject) => {
        if (state.organization) resolve(state.organization);
        else {
          state.organization = (await Vue.http.get("organizations/me")).body;
          resolve(state.organization);
        }
      });
    },
    activateUser({ state }, id) {
      console.log(id);
      return Vue.http.put(`organizations/me/users/${id}/activate`).then(() => {
        Vue.set(state.users.find((u) => u.id == id), "deactivated", false);
      });
    },
    deactivateUser({ state }, id) {
      return Vue.http.put(`organizations/me/users/${id}/deactivate`).then(() => {
        Vue.set(state.users.find((u) => u.id == id), "deactivated", true);
      });
    },

    addUser({ state }, user) {
      return new Promise((resolve, reject) => {
        Vue.http
          .post("organizations/me/users", user, { emulateJSON: true })
          .then((result) => {
            resolve(true);
            state.users.push(result.body);
            return result.body;
          })

          .catch((error) => {
            reject(error);
          });
      });
    },

    addApi({ state }, apiKey) {
      return new Promise((resolve, reject) => {
        Vue.http
          .post("organizations/me/apikeys", apiKey, { emulateJSON: true })
          .then((result) => {
            result.body.newApiKey = true;
            state.apiKeys.push(result.body);
            resolve(result.body);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // changePassword({ state }, data) {
    //   return Vue.http.put("users/me/password", data, {
    //     emulateJSON: true
    //   });
    // },

    // async changePassword({ state }, data) {
    //   return (await Vue.http.put("users/me/password", data)).body
    // },

    async changePassword({ state }, data) {
      return new Promise((resolve, reject) => {
        Vue.http
          .put("users/me/password", data)
          .then((result) => {
            console.log(result.body);
            if (result.body === false) {
              reject(result);
            } else {
              // state.data = result.body;
              resolve(true);
              return result.body;
            }
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },

    changeUserInfo({ state, dispatch, commit }, user) {
      return new Promise(async (resolve, reject) => {
        Vue.http
          .put("users/me", user)
          .then((result) => {
            commit("updateUserInfo", result.body);
            dispatch("getUsers", true);
            resolve(result.body);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },

    changeOrganizationInfo({ state }, org) {
      return new Promise((resolve, reject) => {
        Vue.http.put("organizations/me", org).then((result) => {
          state.organization = result.body;
          resolve(true);
          return result.body;
        });
      });
    },

    renameApi({ state }, apiKey) {
      let scopes = [];
      Object.keys(apiKey.scopes).forEach((key) => {
        let val = apiKey.scopes[key];
        scopes.push(val.uniqueName);
      });

      let newKeyName = { name: apiKey.name, scopes: scopes };
      newKeyName = JSON.stringify(newKeyName);

      return new Promise((resolve, reject) => {
        Vue.http
          .put("organizations/me/apikeys/" + apiKey.id, newKeyName, {
            emulateJSON: true,
          })
          .then((result) => {
            resolve(true);
            return result.body;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    editScopes({ state }, apiKey) {
      const newKeyScopes = { name: apiKey.name, scopes: apiKey.scopes };
      return new Promise((resolve, reject) => {
        Vue.http
          .put("organizations/me/apikeys/" + apiKey.id, JSON.stringify(newKeyScopes), { emulateJSON: true })
          .then((result) => {
            let k = state.apiKeys.find((key) => key.id == apiKey.id);
            k.scopes = result.body.scopes;
            resolve(true);
            // state.apiKeys[state.apiKeys.findIndex(a => a.id == apiKey.id)] = result.body;
            return result.body;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    deleteApi({ state, dispatch }, apiKey) {
      return new Promise((resolve, reject) => {
        dispatch("showConfirmation", {
          title: i18n.t("delete-modal.delete") + " " + apiKey.name + "?",
          confirmButtonText: i18n.t("delete-modal.accept"),
        }).then(
          () => {
            Vue.http.delete("organizations/me/apikeys/" + apiKey.id).then(() => {
              state.apiKeys.splice(state.apiKeys.findIndex((t) => t.id == apiKey.id), 1);
              resolve();
            });
          },
          () => {
            reject();
          },
        );
      });
    },

    getTemplates({ state, commit }) {
      // return new Promise((resolve, reject) => {
      //     state.templates = metadatafile
      //     resolve(metadatafile)
      // })
      return Vue.http.get("templates/metadata").then((result) => {
        state.templates = result.body;
      });
    },

    searchVariables({ state, commit }, { filter, templateId }) {
      return Vue.http
        .get(`templates/${templateId}/search?pageSize=10&query=${encodeURIComponent(filter)}`)
        .then((result) => result.body);
    },

    getVariableFormats({ state, dispatch }, params) {
      const getData = () => {
        return Vue.http.get(`editor/metadata/formats?templateLanguage=${params.templateLanguage}`).then((result) => {
          state.variableFormats = result.body;
          return result.body;
        });
      };
      if (!params.templateLanguage) {
        dispatch("getTemplate", params.templateId).then((res) => {
          params.templateLanguage = res.language;
          getData();
        });
      } else {
        getData();
      }
    },
    getFormatExamples({ getters, state }, { variable, formats }) {
      let dependentVariables = VariableHelpers.getDependentVariables(variable.name, getters.combinedVariables);
      return Vue.http
        .post("editor/variables/format?language=" + state.template.language, {
          dependentVariables,
          variable,
          formats,
        })
        .then((result) => result.body);
    },
    getSynonymFormatExamples({ getters, state }, { synonym, formats, all }) {
      return Vue.http
        .post("editor/synonyms/format?language=" + state.template.language + (all ? "&all=true" : ""), {
          synonym,
          formats,
        })
        .then((result) => result.body);
    },
    publishTemplate({ state }, { publicationName, template, existingPublication }) {
      return Vue.http[existingPublication ? "put" : "post"](
        "templates/" +
          template.id +
          "/publish" +
          (existingPublication ? "/" + existingPublication.id : "?name=" + publicationName.trim()),
      ).then((result) => {
        console.log(result.body);
        if (existingPublication) {
          state.templates.splice(state.templates.findIndex((t) => t.id === existingPublication.id), 1, result.body);
        } else state.templates.push(result.body);

        return result.body;
      });
    },
    deleteTemplate({ state, dispatch }, template) {
      return new Promise((resolve, reject) => {
        dispatch("showConfirmation", {
          title:
            i18n.t("delete-modal.delete") +
            " " +
            (template.published ? i18n.t("delete-modal.publication") : i18n.t("delete-modal.template")) +
            "?",
          description:
            i18n.t("delete-modal.desc-one") +
            (template.published ? i18n.t("delete-modal.publication") : i18n.t("delete-modal.template")) +
            i18n.t("delete-modal.desc-two"),
          confirmButtonText: i18n.t("delete-modal.accept"),
        }).then(
          () => {
            Vue.http.delete("templates/" + template.id).then(() => {
              state.templates.splice(state.templates.findIndex((t) => t.id == template.id), 1);

              resolve();
            });
          },
          () => {
            reject();
          },
        );
      });
    },
    createTemplate({ dispatch, commit }, { templateName, contentType, contentSource, language }) {
      return Vue.http
        .post("templates", {
          name: templateName,
          language: language,
          contentType: contentType,
          sources: contentSource,
          template: {},
        })
        .then((result) => {
          commit("addTemplate", result.body.metadata);
          dispatch("addDefaultTemplateSettings", result.body);
        });
    },
    showConfirmation({}, { title, description, confirmButtonText }) {
      let modal = this._vm.$modal;
      return new Promise((resolve, reject) => {
        let confirmed = false;
        modal.show(
          ConfirmModal,
          {
            title: title,
            description: description,
            confirmButtonText: confirmButtonText,
            onConfirm: (result) => {
              confirmed = true;
              resolve(result);
            },
          },
          { width: 310, height: "auto", adaptive: true },
          {
            "before-close": (event) => {
              if (!confirmed) reject();
            },
          },
        );
      });
    },
    // getContentSources({ state }) {
    //   return new Promise((resolve, reject) => {
    //     if (state.contentSources.length) resolve(state.contentSources);
    //     else
    //       Vue.http.get("organizations/me/sources").then(result => {
    //         state.contentSources = result.body;
    //         resolve(state.contentSources);
    //       });
    //   });
    // },

    getContentSources({ state }) {
      return new Promise((resolve, reject) => {
        Vue.http.get("organizations/me/sources").then((result) => {
          state.contentSources = result.body;
          // console.log(result.body)
          resolve(state.contentSources);
        });
      });
    },
    getIntegrationSettings({ state }, settings) {
      return new Promise((resolve, reject) => {
        let sources;
        if (settings) {
          sources = settings;
        } else {
          const connectors = state.contentTypes.filter((c) =>
            state.fixedConnectors.map((f) => f.value).includes(c.name),
          );
          sources = connectors.map((c) => c.name);
        }
        Vue.http.post("organizations/me/sources/settings", { sources: sources }).then((result) => {
          if (settings) {
            const settingsKeys = Object.keys(result.body);
            settingsKeys.forEach((setting) => {
              if (!state.connectorSettings[setting]) Vue.set(state.connectorSettings, setting, result.body[setting]);
            });
          } else {
            state.connectorSettings = result.body;
          }
          resolve(result.body);
        });
      });
    },

    createFixedIntegration({ state, dispatch }, { integrationEnumName, settings }) {
      return new Promise((resolve, reject) => {
        let connector = new Connector(
          integrationEnumName,
          state.fixedConnectors.find((c) => c.value == integrationEnumName).name,
        );
        settings.forEach((setting) => {
          if (setting.default) {
            connector.config[setting.id] = setting.default;
          }
        });
        Vue.http
          .post("organizations/me/sources", connector)
          .then((result) => {
            dispatch("getContentTypes", true)
              .then(() => dispatch("getContentSources"))
              .then(() => dispatch("getContentSources2", true))
              .then(() => resolve(result.body));
          })
          .catch((error) => {
            console.log("error", error);
            reject(error);
          });
      });
    },

    editFixedIntegration({ state }, integration) {
      console.log(integration);
      return new Promise((resolve, reject) => {
        Vue.http
          .put("organizations/me/sources/" + integration.enumName, integration)
          .then((result) => {
            console.log(result.body);
            result.body.fixedIntegration = true;
            resolve(result.body);
            return result.body;
          })
          .catch((error) => {
            console.log("error", error);
            reject(error);
          });
      });
    },

    deleteFixedIntegration({ state, dispatch }, integration) {
      return new Promise((resolve, reject) => {
        
          Vue.http
            .delete("organizations/me/sources/" + integration.enumName + "?sourceId=" + integration.id, integration)
            .then(() => {
              // Check if last
              const lastFixed = !state.contentSources.some(
                (source) => source.contentType.id == integration.contentType.id && source.id != integration.id,
              );
              if (lastFixed) {
                state.filters.splice(state.filters.findIndex((f) => f.name == integration.name), 1);
              }
              dispatch("getContentSources")
                .then(() => dispatch("getContentSources2", true))
                .then(() => dispatch("getContentTypes", true));
              resolve(lastFixed);
            })
            .catch((error) => {
              console.log("error", error);
              reject(error);
            });
        
      });
    },

    getContentSources2({ state, commit }, refresh) {
      return new Promise(async (resolve, reject) => {
        if (!refresh && state.contentSources2.length) resolve(state.contentSources2);
        else {
          state.contentSources2 = (await Vue.http.get("contentsources")).body;
          resolve(state.contentSources2);
        }
      });
    },

    getContentSource({ state }, sourceId) {
      return new Promise((resolve, reject) => {
        Vue.http
          .get(`contentsources/${sourceId}`)
          .then((res) => {
            resolve(res.body);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    getDummyData({ state, commit }, contentSource) {
      return new Promise(async (resolve, reject) => {
        await Vue.http.get(`contentsources/${contentSource.id}/dummydata`).then((res) => {
          resolve(res.body);
        });
      });
    },

    getContentTypes({ state, commit }, refresh) {
      return new Promise(async (resolve, reject) => {
        if (!refresh && state.contentTypes.length) resolve(state.contentTypes);
        else {
          state.contentTypes = (await Vue.http.get("contentsources/types")).body;
          resolve(state.contentTypes);
        }
      });
    },

    deleteContentType({ state, dispatch }, contentType) {
      return new Promise((resolve, reject) => {
        dispatch("showConfirmation", {
          title: i18n.t("delete-modal.delete") + " " + contentType.name + "?",
          confirmButtonText: i18n.t("delete-modal.accept"),
        }).then(() => {
          Vue.http
            .delete("contentsources/types/" + contentType.id)
            .then(() => {
              state.contentTypes.splice(state.contentTypes.findIndex((t) => t.id == contentType.id), 1);
              state.filters.splice(state.filters.findIndex((f) => f.name == contentType.name), 1);
              resolve(true);
            })
            .catch((error) => {
              console.log("error", error);
              reject(error);
            });
        });
      });
    },

    createContentType({ state, dispatch }, contentType) {
      return new Promise((resolve, reject) => {
        Vue.http
          .post("contentsources/types?name=" + contentType, {
            emulateJSON: true,
          })
          .then((result) => {
            let filter = {
              name: result.body.name,
              id: result.body.name.toLowerCase(),
              categories: [result.body.name],
              custom: result.body.custom,
            };
            // state.filters.push(filter);
            // dispatch('setCategoryFilter', true).then(() => resolve(true))
            resolve(result);
            state.contentTypes.push(result.body);
            return result.body;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    createSource({ state, dispatch }, contentSource) {
      console.log(contentSource);
      return new Promise((resolve, reject) => {
        Vue.http
          .post("contentsources", contentSource, { emulateJSON: true })
          .then((result) => {
            console.log(result);
            dispatch("getContentSources2", true).then(() => resolve(true));
          })

          .catch((error) => {
            reject(error);
          });
      });
    },

    async createDummy({ state, dispatch }, dummySourceData) {
      return new Promise((resolve, reject) => {
        let req = new XMLHttpRequest();
        let formData = new FormData();
        Object.keys(dummySourceData).forEach((key) => formData.append(key, dummySourceData[key]));
        req.open("POST", `${state.apiUrl}contentsources/${dummySourceData.sourceId}/dummydata`);
        req.setRequestHeader("Authorization", "Bearer " + state.token.access_token);
        req.onreadystatechange = function() {
          if (this.readyState == 4) {
            // let response = JSON.parse(this.responseText)
            if (this.status == 200) {
              const res = JSON.parse(this.responseText);
              resolve(res);
            }
            // else reject(this.responseText)
            else reject();
          }
        };
        req.send(formData);
      });
    },

    handleMultiFileUpload({ state, dispatch }, fileData) {
      return new Promise((resolve, reject) => {
        Vue.http
          .post(`contentsources/${fileData.sourceId}/dummydata/map`, fileData.fileData)
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err.error);
          });
      });
    },

    sendExportLink({ state }, exportData) {
      return new Promise((resolve, reject) => {
        Vue.http
          .post(`templates/${exportData.publicationId}/export`, exportData.exportModel)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    cancelVariableMapping({ state }, fileName) {
      return new Promise((resolve, reject) => {
        Vue.http
          .post("contentsources/dummydata/map/cancel", { fileName: fileName })
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    deleteDummy({ state, dispatch }, dummySourceData) {
      return new Promise((resolve, reject) => {
        dispatch("showConfirmation", {
          title: i18n.t("delete-modal.delete"),
          description: dummySourceData.dummy.name + "?",
          confirmButtonText: i18n.t("delete-modal.accept"),
        }).then(
          () => {
            Vue.http
              .delete(`contentsources/${dummySourceData.sourceId}/dummydata/${dummySourceData.dummy.id}`)
              .then(() => {
                resolve();
              });
          },
          () => {
            reject();
          },
        );
      });
    },

    editSource({ state }, contentSource) {
      return new Promise((resolve, reject) => {
        Vue.http
          .put("contentsources/" + contentSource.id, JSON.stringify(contentSource), { emulateJSON: true })
          .then((result) => {
            let cSource = state.contentSources2.find((s) => s.id == contentSource.id);
            cSource.dataURL = result.body.dataURL;
            cSource.searchURL = result.body.searchURL;
            cSource.exampleId = result.body.exampleId;
            cSource.name = result.body.name;
            resolve(true);
            return result.body;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    deleteSource({ state, dispatch }, contentSource) {
      return new Promise((resolve, reject) => {
        Vue.http
          .delete("contentsources/" + contentSource.id)
          .then(() => {
            state.contentSources2.splice(state.contentSources2.findIndex((t) => t.id == contentSource.id), 1);
            dispatch("getContentSources");
            resolve();
          })
          .catch((e) => {
            reject();
          });
      });
    },

    updateTemplateMetadata({ state }, templateMetadata) {
      console.log(templateMetadata);
      return new Promise((resolve, reject) => {
        Vue.http.put("templates/" + templateMetadata.id + "/metadata", templateMetadata).then((result) => {
          console.log(result.body);
          state.templates[state.templates.findIndex((t) => t.id === templateMetadata.id)] = result.body;
          return result.body;
        });
      });
    },

    duplicateTemplate({ state, dispatch }, newInfo) {
      return new Promise((resolve, reject) => {
        Vue.http
          .post(`templates/${newInfo.existingId}/copy?newLanguage=${newInfo.newLanguage}&newName=${newInfo.newName}`, {
            emulateJSON: true,
          })
          .then((result) => {
            resolve(true);
            return dispatch("getTemplates");
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    getPublicationStats({ state }, id) {
      return new Promise((resolve, reject) => {
        Vue.http
          .get(`templates/${id}/usage`, { emulateJSON: true })
          .then((result) => {
            state.publicationStats = result.body;
            resolve(result.body);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    sendStatsLink({ state }, data) {
      console.log(data);
      return new Promise((resolve, reject) => {
        Vue.http
          .get(
            `templates/${data.publicationId}/usagereport?timespan=${data.formData.timespan}&email=${
              data.formData.email
            }`,
          )
          .then((result) => {
            console.log("Email sent");
            resolve(result.body);
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },

    getSingleItemStats({ state }, info) {
      return new Promise((resolve, reject) => {
        Vue.http
          .get(`templates/${info.publicationId}/${info.contentId}/usage`, {
            emulateJSON: true,
          })
          .then((result) => {
            if (info.contentId == "") {
              state.publicationSingleItemStats = [];
            } else {
              state.publicationSingleItemStats = result.body;
              resolve(result.body);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getFavorites({ state }) {
      let STORAGE_KEY = "template-" + state.template.metadata.id;
      state.dataFavorites = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    },
    toggleFavorites({ state }, dataSet) {
      let STORAGE_KEY = "template-" + state.template.metadata.id;
      if (state.dataFavorites.some((favorite) => favorite.id == dataSet.id)) {
        state.dataFavorites.splice(state.dataFavorites.findIndex((favorite) => favorite.id == dataSet.id), 1);
      } else {
        state.dataFavorites.push(dataSet);
      }
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state.dataFavorites));
    },

    getTemplateBackups({ state }, templateId) {
      state.templateBackups = [];
      return new Promise((resolve, reject) => {
        Vue.http
          .get(`templates/${templateId}/backups`)
          .then((result) => {
            state.templateBackups = result.body;
            resolve(result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getBackupInfo({ state }, data) {
      console.log(data);
      return new Promise((resolve, reject) => {
        Vue.http
          .get(`templates/${data.templateId}/backups/${data.backupId}`)
          .then((result) => {
            // console.log(result)
            resolve(result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    revertTemplate({ state, dispatch }, data) {
      console.log(data);
      return new Promise((resolve, reject) => {
        Vue.http
          .put(`templates/${data.templateId}/backups/${data.backupId}/revert`)
          .then((result) => {
            console.log(result);
            resolve(result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    validateResetToken({ state }, data) {
      // console.log(data)
      return new Promise((resolve, reject) => {
        Vue.http
          .post(`validateresettoken`, data)
          .then((result) => {
            // console.log(result)
            resolve(result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    createNewPassword({ state }, data) {
      return new Promise((resolve, reject) => {
        Vue.http
          .post(`resetpassword`, data)
          .then((result) => {
            resolve(result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    sendResetPassword({ state }, data) {
      return new Promise((resolve, reject) => {
        Vue.http
          .get(`sendresetpasswordmessage/` + data)
          .then((result) => {
            resolve(result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getSubscriptionPlans({ state }) {
      return new Promise((resolve, reject) => {
        Vue.http
          .get("subscription/plans")
          .then((result) => {
            console.log(result);
            state.subscriptionPlans = result.body;
            resolve(result);
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
    getSetupintent({ state }) {
      return new Promise((resolve, reject) => {
        Vue.http
          .get("subscription/setupintent")
          .then((result) => {
            state.setupintent = result.body;
            resolve(result.body);
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
    createSubscription({ state }, data) {
      console.log(data);
      return new Promise((resolve, reject) => {
        Vue.http
          .post("organizations/me/subscribe", data)
          .then((result) => {
            resolve(result);
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
    getSubscriptions({ state }) {
      return new Promise((resolve, reject) => {
        Vue.http
          .get("organizations/me/subscriptions")
          .then((result) => {
            console.log(result.body);
            resolve(result.body);
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },

    async getCountry({ state }, searchTerm) {
      return new Promise((resolve, reject) => {
        fetch("https://restcountries.com/v3.1/name/" + searchTerm)
          .then((res) => res.json())
          .then((res) => {
            let resultList = [];
            res.forEach((r) => {
              const country = {
                name: r.name.common,
                cca2: r.cca2,
                flag: r.flags.svg,
              };
              if (state.validCountryCodes.includes(country.cca2)) resultList.push(country);
            });
            resolve(resultList);
          })
          .catch((e) => {
            console.log(e);
            reject(e);
          });
      });
    },

    testSourceConnection({ state }, id) {
      return new Promise((resolve, reject) => {
        Vue.http
          .get(`organizations/me/sources/${id}/test`)
          .then((res) => {
            resolve(res.body);
          })
          .catch((e) => console.log(e));
      });
    },

    testSourceConnections({ state }, ids) {
      const params = ids.map((c) => "sourceIds=" + c);
      return new Promise((resolve, reject) => {
        Vue.http
          .get(`organizations/me/sources/test?${params.join("&")}`)
          .then((res) => {
            resolve(res.body);
          })
          .catch((e) => console.log(e));
      });
    },

    getTemplateSettings({ state }, id) {
      return Vue.http.get(`templates/${id}/settings`).then((result) => result.body);
    },

    getTemplateSettingsFields({ state }, id) {
      return Vue.http.get(`templates/${id}/settingsfields`).then((result) => result.body);
    },

    saveTemplateSettings({ commit }, { id, settings }) {
      return new Promise((resolve, reject) => {
        Vue.http
          .put(`templates/${id}/settings`, settings)
          .then((res) => {
            console.log(res);
            commit("setTemplateSettings", { id, settings });
            resolve(res.body);
          })
          .catch((e) => reject(e));
      });
    },
    addDefaultTemplateSettings({ state, dispatch }, template) {
      dispatch("getTemplateSettingsFields", template.metadata.id).then((res) => {
        let templateSettings = {};
        res.forEach((e) => {
          templateSettings[e.id] = e.default;
        });
        dispatch("saveTemplateSettings", { id: template.metadata.id, settings: templateSettings });
      });
    },
  },
});
